export default __webpack_public_path__ + "static/media/page-headline.ae5bece2.jpg";